<template>
	<div class="activity-reaction-body">
		<ProfilePic
			v-if="targetUser"
			:user="targetUser"
			size="36px"
			class="reaction-avatar"
		/>
		<div class="reaction-content">
			<p class="reaction-text">
				<i18n-t keypath="admin_activity_reacted_with" tag="span">
					<template #emoji>{{ item.emoji }}</template>
					<template #target>{{ targetName }}</template>
				</i18n-t>
				<span v-if="hasTargetText" class="reaction-quote">
					&nbsp;&ldquo;<ActivityText :message="item.message" />&rdquo;
				</span>
			</p>
		</div>
	</div>
</template>

<script>
import { ProfilePic } from '@/components/common'
import ActivityText from './ActivityText'

export default {
	name: 'ActivityReactionBody',

	components: { ProfilePic, ActivityText },

	props: {
		item: { type: Object, required: true },
	},

	computed: {
		targetUser() {
			return this.item.message?.user || null
		},

		targetName() {
			return (
				this.targetUser?.fullname ||
				this.targetUser?.full_name ||
				this.$t('chat_message_unknownuser')
			)
		},

		hasTargetText() {
			return !!(this.item.message?.text || '').trim()
		},
	},
}
</script>

<style lang="scss" scoped>
.activity-reaction-body {
	display: flex;
	gap: 19px;
	align-items: flex-start;
}

.reaction-avatar {
	flex-shrink: 0;
}

.reaction-content {
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: 5px;
}

.reaction-text {
	margin: 0;
	font-family: Avenir-Roman;
	font-size: 17px;
	line-height: 24px;
	color: var(--neutral-800);
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden;
}

.reaction-quote {
	color: var(--neutral-600);
}
</style>
